import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@/hooks/useAuth';
import { companiesApi } from '@/lib/companies';
import { api } from '@/lib/api';

interface WorkspaceLite { id: string; name: string; fyLabel: string }

export function AppHome() {
  const { t } = useTranslation();
  const { data: user, isLoading } = useCurrentUser();
  const { data: companies, isLoading: companiesLoading } = useQuery({
    queryKey: ['companies'],
    queryFn: () => companiesApi.list(),
    enabled: !!user,
  });
  const firstCompanyId = companies?.[0]?.id;
  const { data: workspaces, isLoading: wsLoading } = useQuery({
    queryKey: ['workspaces', firstCompanyId],
    queryFn: async () => (await api.get<WorkspaceLite[]>('/api/workspaces', { params: { companyId: firstCompanyId } })).data,
    enabled: !!firstCompanyId,
  });

  if (isLoading || companiesLoading || (firstCompanyId && wsLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-500 text-sm">
        {t('common.loading')}
      </div>
    );
  }
  if (!user) return <Navigate to="/?auth=required" replace />;
  if (!companies || companies.length === 0) return <Navigate to="/onboarding" replace />;
  if (workspaces && workspaces.length > 0) return <Navigate to={`/app/workspace/${workspaces[0].id}`} replace />;

  return (
    <div className="min-h-screen flex items-center justify-center text-ink-500 text-sm">
      {t('app.no_workspaces')} <a href="/onboarding" className="ml-1 text-accent-600 underline">{t('app.set_one_up')}</a>.
    </div>
  );
}
